import { Box, TextField, Typography } from '@mui/material';
import {
  ChannelTabs,
  DurationField,
} from 'components/@home/@settings/Tabs/Agents/panels/ChannelTabs';
import {
  SettingsToggleRow,
  useConfigurationSectionSx,
} from 'components/@home/@settings/Tabs/Agents/panels/configurationSectionStyles';
import { normalizeTimeoutSettings } from 'components/@home/@settings/Tabs/Agents/panels/timeoutDefaults';
import { bool, func, object, string } from 'prop-types';
import React, { useState } from 'react';
import { I18n } from 'utils/i18n';

const Step = ({ titleKey, step, hasMessage, unit, onChangeUnit, onPatch, isFirst }) => {
  const sx = useConfigurationSectionSx();
  return (
    <Box sx={isFirst ? sx.section : sx.step}>
      <SettingsToggleRow
        label={I18n.t(`AgenticChatFlow.${titleKey}`)}
        checked={Boolean(step.enabled)}
        onChange={e => onPatch({ enabled: e.target.checked })}
      />
      <Typography sx={[sx.fieldLabel, { mt: 2 }]}>
        {I18n.t('AgenticChatFlow.InactivityAfter')}
      </Typography>
      <DurationField
        seconds={step.durationSeconds}
        unit={unit}
        onChangeSeconds={s => onPatch({ durationSeconds: s })}
        onChangeUnit={onChangeUnit}
      />
      {hasMessage && (
        <>
          <Typography sx={[sx.fieldLabel, { mt: 2 }]}>
            {I18n.t('AgenticChatFlow.InactivityMessage')}
          </Typography>
          <TextField
            size="small"
            fullWidth
            multiline
            minRows={2}
            value={step.message || ''}
            onChange={e => onPatch({ message: e.target.value })}
          />
        </>
      )}
    </Box>
  );
};
Step.propTypes = {
  titleKey: string.isRequired,
  step: object.isRequired,
  hasMessage: bool,
  unit: string.isRequired,
  onChangeUnit: func.isRequired,
  onPatch: func.isRequired,
  isFirst: bool,
};

const InactivityHandlingCard = ({ draft, onPatch }) => {
  const sx = useConfigurationSectionSx();
  const [channel, setChannel] = useState('chat');
  const [unit, setUnit] = useState('seconds');
  const ts = normalizeTimeoutSettings(draft.timeoutSettings);
  const inactivity = ts[channel].inactivity;

  const patchStep = (key, next) => {
    onPatch('timeoutSettings', {
      ...ts,
      [channel]: {
        ...ts[channel],
        inactivity: { ...inactivity, [key]: { ...inactivity[key], ...next } },
      },
    });
  };

  return (
    <Box sx={[sx.section, sx.card]}>
      <Typography sx={sx.sectionTitle}>{I18n.t('AgenticChatFlow.InactivityTitle')}</Typography>
      <Typography sx={sx.sectionHelper}>{I18n.t('AgenticChatFlow.InactivityHelper')}</Typography>
      <ChannelTabs channel={channel} onChange={setChannel} />
      <Step
        titleKey="InactivityCheckIn"
        step={inactivity.checkIn}
        hasMessage
        isFirst
        unit={unit}
        onChangeUnit={setUnit}
        onPatch={n => patchStep('checkIn', n)}
      />
      <Step
        titleKey="InactivityGoodbye"
        step={inactivity.goodbye}
        hasMessage
        unit={unit}
        onChangeUnit={setUnit}
        onPatch={n => patchStep('goodbye', n)}
      />
      <Step
        titleKey="InactivityEndConversation"
        step={inactivity.endConversation}
        unit={unit}
        onChangeUnit={setUnit}
        onPatch={n => patchStep('endConversation', n)}
      />
    </Box>
  );
};

InactivityHandlingCard.propTypes = { draft: object.isRequired, onPatch: func.isRequired };

export default InactivityHandlingCard;
